<template lang="html">
  <section id="sol_dowpayment" class="sol_dowpayment">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <h3 class="card-text margin-b-md">Filters</h3>
              <hr>
              <b-row class="just-sb m-0">
                <div class="col-lg-6 row">
                  <b-col class="col-lg-2 pt-2">Market:</b-col>
                  <b-select class="col-lg-10" v-model="selectedCountry" id="selectedCountry"  v-on:change="isPostPriceConf=false">
                    <b-form-select-option :value="null">---</b-form-select-option>
                    <b-form-select-option :value="country" v-for="(country,index) in countryList">{{country.description}}</b-form-select-option>
                  </b-select>
                </div>
              </b-row>
              <br>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Sol Downpayments:</h4>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                </div>              
               </div>
                <div class="col-lg-1">
                  <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                    <b-form-select-option value="5">5</b-form-select-option>
                    <b-form-select-option value="10">10</b-form-select-option>
                    <b-form-select-option value="15">15</b-form-select-option>
                    <b-form-select-option value="20">20</b-form-select-option>
                    <b-form-select-option value="50">50</b-form-select-option>
                    <b-form-select-option value="100">100</b-form-select-option>
                  </b-form-select>
              </div>
            <div class="col-lg-7">
              <span class="float-right">
                <template>                
                  <b-button variant="primary mr-1" @click="refreshTable()"><i class="mdi mdi-refresh"></i>Apply</b-button>
                  <b-button variant="primary mr-1" v-b-toggle.filters><i class="mdi mdi-filter"></i></b-button>
                  <b-button variant="primary mr-1" v-b-modal.modal-new @click="importFromNewModal=true"><i class="mdi mdi-plus"></i>New</b-button>
                </template>                
              </span>
            </div>
            <div id="overflow_nav_buttons" v-show="showNavButtons">
              <span id="left_b" class="ovf_nav_btn_l" @click="scrollXPage('#table',0)">
                <i class="mdi mdi-chevron-double-left"></i>
              </span>
              <span id="right_b" class="ovf_nav_btn_r" @click="scrollXPage('#table',1)">
                <i class="mdi mdi-chevron-double-right"></i>
              </span>
            </div>
            <b-table v-resize="toogleNavButtons"
              id="table" 
              striped 
              hover 
              responsive 
              :per-page="perPage"
              :current-page="1"
              :items="items" 
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key=""
              no-local-sorting
              no-provider-paging
            >
              <!-- Data -->      

              <template v-slot:cell(market)="data" lang="html">
                {{data.item.country.codmercato}}                
              </template>

              <template v-slot:cell(downpayment)="data" lang="html">
                <input @keypress="isNumber($event)"  type="number" class="disc-input disc-input-large" v-model="data.item.downpayment" placeholder="---"/>
              </template>
              
              <template v-slot:cell(active)="data" lang="html">
                 <b-row>
                  <b-button v-if="!data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Activate" @click="toggleElementStatus(data.item,true)">
                    <i class="mdi mdi-delete" style="display: block;"></i>
                  </b-button>
                  <b-button v-else="data.item.active" class="btn p-1 m-auto btn-danger btn-sm" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover  title="Delete" @click="toggleElementStatus(data.item,false)">
                      <i class="mdi mdi-delete" style="display: block;"></i>
                  </b-button>
                </b-row>
                <b-row v-if="false">
                  <b-button v-if="!data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Activate" disabled>
                    <i class="mdi mdi-delete" style="display: block;"></i>
                  </b-button>
                  <b-button v-else="data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover  title="Delete" disabled>
                      <i class="mdi mdi-delete" style="display: block;"></i>
                  </b-button>
                </b-row>
              </template>             
              <template v-slot:cell(save)="data" lang="html">
                 <b-row>
                  <h4 class="panel-title" style="margin:auto;">                 
                    <b-button class="col-lg-5 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="update"  @click="checkDownpaymentAndSaveItem(data.item, false)">
                      <i class="mdi mdi-content-save"></i>
                    </b-button>
                  </h4>
                </b-row>
              </template>
              <template v-slot:cell(lastUpdate)="data" lang="html">
                {{customFormatter(data.item.lastUpdate, data.item)}}
              </template>
            </b-table>
            <!-- Modal New -->
            <b-modal id="modal-new" title="New" size="lg" header-bg-variant="primary" header-text-variant="light" centered  @close="closeModalNew()" @hide="closeModalNew()">
              <b-container fluid>
                  <br>
                  <b-row class="m-0">                    
                    <b-col class="col-lg-2">Market*:</b-col>
                    <b-select class="col-lg-2" v-model="newItem.country" id="newCountry">
                          <b-form-select-option :value="{}">---</b-form-select-option>
                          <b-form-select-option :value="country" v-for="(country,index) in countryList">{{country.description}}</b-form-select-option>
                    </b-select>
                    <div class="col-lg-2"></div>
                    <div class="col-lg-2">Downpayment:</div>
                    <input @keypress="isNumber($event)" type="number" min="0"  v-on:input="checkMaxInsert(newItem.downpayment)"  class="col-lg-2" placeholder="Downpayment:" v-model.number="newItem.downpayment"/>
                    
                  </b-row>
                  <hr>                 
                  <br><br>                      
                <p style="color:red;text-align: center;"></p>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>                  
                  <b-button v-if="showSaveButton(newItem)" variant="primary" @click="checkDownpaymentAndCreateItem()">
                    Save
                  </b-button>
                  <b-button v-else  variant="primary" disabled>
                    Save
                  </b-button>
                </fragment>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
  thead[role=rowgroup] >  tr[role=row] >  th[role=columnheader] { text-align: right;} 
  tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container { position: inherit;  white-space: initial;}
  tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container > .vdp-datepicker { position: inherit;  white-space: unset;}
  tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container > .vdp-datepicker > .vdp-datepicker__calendar { position: absolute;  white-space: unset;}
  tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container  > .timepicker-container > .display-time {border: white; color: black;};
  tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container_grid  > .timepicker-container > .display-time {border: white; color: black;};
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
import mixin from '../../mixin/mixin.js'
import Datepicker from 'vuejs-datepicker';
const FileDownload = require('js-file-download');
const MomentWithTimezone = require('moment-timezone');
import moment from 'moment';
import VueTimepicker from 'vue2-timepicker/src'

export default {
  name: 'sol_dowpayment',
  mixins: [mixin],
  methods: {
    closeModelDescription(item){
      if(item)
        item.description = this.oldDescription;
      this.$bvModal.hide('modal-description');
    },
    inputHandlerNew(eventData, item, isStart) {
      var time = eventData.data;
      if(time.HH && time.mm){
        var date = isStart ? item.dateTimeStartUTC : item.dateTimeEndUTC;
        date = moment(date);
        date.hour(time.HH);
        date.minutes(time.mm);

        if(isStart){
          item.dateTimeStartUTC = new Date(date);
        }else{
          item.dateTimeEndUTC = new Date(date);
        };
      }
    },
    inputHandler(eventData, item, isStart){
      var time = eventData.data;
      if(time.HH && time.mm){
        var date = isStart ? item.dateStart : item.dateEnd;
        date = moment(date);
        date.hour(time.HH);
        date.minutes(time.mm);

        if(isStart){
          item.dateStart = new Date(date);
        }else{
          item.dateEnd = new Date(date);
        };
      }
    },
     goToPriceConf(vetele, idCountry){
      this.setSpinnerStatus(true);
      this.axios
      .post("/ccb/auth/fe/commercialModel/checkIfExistVeteleActive/"+vetele, null, this.authHeader)
      .then(response => {
        if(response.status == 200){
          if(this.$route.params.from == 'price_conf') {
            this.setComeFromSolCampaign(true);
            this.setStartFromSolCampaign(false);
          } else {
            this.setComeFromSolCampaign(false);
             this.setStartFromSolCampaign(true);
             if(this.selectedCountry)
              this.filterObj.idCountry = this.selectedCountry.id;
              this.setDate();      
             this.setOriginalCampaignObject({filterObj : this.filterObj, from: 'sol_dowpayment'})
          }
         
          this.$router.push({name: "price_configurator", params: { vetele : vetele, idCountry: this.curItem.idCountry, idCampaign : this.curItem.id, from: 'sol_dowpayment'}});
        }       
      }).catch(error => {
        this.$bvModal.msgBoxOk("Downpayment not active", {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
      .finally(e=>{
        this.setSpinnerStatus(false);
      })
    },
    customTimeFormatter(date){
      if(date != null){
        return moment(date).format('HH:mm');
      } else
        return null;
    },
    customFormatter(date) {
      if(date != null){
        return moment(date).format('DD/MM/YY');
      }
    }, 
    checkMax(item, opt){
      var data = opt ? item.discOpt : item.discPerc;
      if(data && parseInt(data) > 100){
        if(opt){
          item.discOpt = 100;
        }else{
          item.discPerc = 100;
        }
      };
    },
     checkMaxInsert(data){
      if(data && parseInt(data) > 100){
          data = 100;
      }
    },
    checkDateEnd(item, dateEnd){
      if(dateEnd){
          var end = new Date(dateEnd);
          var dateWithTime = moment(end);
          if(dateWithTime){
            dateWithTime.hour("00");
            dateWithTime.minutes("00");
            item.dateEnd = dateWithTime._d;
          }
      }
    },
    checkDateNew(item, dateStart, dateEnd){
      var start = new Date(dateStart);
      var end = new Date(dateEnd);
      if(start){
        var dateWithTime = moment(start);
        if(dateWithTime){
          dateWithTime.hour("00");
          dateWithTime.minutes("00");
          item.dateStart = dateWithTime._d;
        }
      }
      if((start.getTime() > end.getTime()) || (start.toDateString() == end.toDateString())){
        var dateWithTime = moment(end);
        if(dateWithTime){
          dateWithTime.hour("00");
          dateWithTime.minutes("00");
          item.dateEnd = dateWithTime._d;
          setTimeout(function () {
            item.dateEnd = null;
          }, 250);
        }
    } 
    },
    openDescriptionModal(data){
      this.oldDescription = data.description;
      this.curItemTemp = data;
      this.$bvModal.show('modal-description');
    },
    closeModalNew(){
      this.selectedNewModel = null;
      this.itemsModel = [];
      this.newItem = { id: null, country: {}, downpayment: null, active: true, insertUser: null, insertDate: null, updateUser: null, updateDate: null };
    },
    closeModalEdit(){
       this.selectedEditModel = null;
      this.curItem = null;
      this.itemsModel = [];
      this.refreshTable();
    },
    closeModal(){
      this.fileName = null;
    },
    toggleElementStatus(item, visibilityValue) {
      var stato = (!visibilityValue) ? 'deactivate' : 'activate'
      this.$bvModal.msgBoxConfirm('Do you want to '+stato+' this Downpayment '+item.country.codmercato+' ?', {
        title: 'Change Status',
        okVariant: 'danger',
        okTitle: 'Continue',
        cancelTitle: 'Cancel',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.active(visibilityValue, item.id);         
        }
      })
    },
    saveCurItem(curItem, editMode) {
      var intLabObj = curItem
      intLabObj.lastUpdate = new Date();
      this.setSpinnerStatus(true);
      var urlBase = '/ccb/auth/fe/downpayment/update/' + intLabObj.id ; 
      this.axios
      .put(urlBase, intLabObj, this.authHeader)
      .then(response => {
        if(response.status == 200 || response.status == 201) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            this.refreshTable();            
          })
        }    
      })
      .catch(error => {
      this.$bvModal.msgBoxOk(error.message, {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
      })
      .finally(e=>{        
        this.setSpinnerStatus(false);
      })
    },   
    active(active, id) {
      this.setSpinnerStatus(true);
      var urlBase = '/ccb/auth/fe/downpayment/active/' + id + "/" +  active  ; 
      this.axios
      .put(urlBase, null, this.authHeader)
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            this.refreshTable();
          })
        }    
      })
      .catch(error => {
      this.$bvModal.msgBoxOk(error.message, {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
      })
      .finally(e=>{
        this.refreshTable();
        this.setSpinnerStatus(false);
      })
    },   
    exportXlxs(isOnlyTemplate){
      this.setSpinnerStatus(true);
      let params = {
        scope: this.selectedScopeExport,
        isOnlyTemplate: isOnlyTemplate
      }
      this.axios
      .post('/ccb/auth/fe/solCampaign/toXlsx', this.filterObj, {
        responseType: 'blob',
        params: params,
        ...this.authHeader})
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true,
          })
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    showSaveButton(item){
      return (item.country  && item.downpayment);
    },
    showEditButton(item){
      return item.country && item.country.id && item.downpayment && item.active;
    },
    createItem() {
      var date =  new Date();
      var intLabObj = this.newItem;
      this.setSpinnerStatus(true);
      console.log(intLabObj)

      this.axios
      .post('/ccb/auth/fe/downpayment', intLabObj, this.authHeader)
        .then(response => {
          window.risposta = response;
          console.log(response)
          if(response.status == 200 || response.status == 201) {
            this.$bvModal.msgBoxOk('Created!', {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              this.curItem = intLabObj;
             this.refreshTable()
              this.$bvModal.hide('modal-new')
            })           
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e=>{
          this.setSpinnerStatus(false);
        })         
    },
    setDate(){
      var year = '';
      var month = '';
      var day = '';
  
      if(this.filterObj.dateEnd){
        var date = this.filterObj.dateEnd;
        var day = moment(date,"DD/MM/YYYY").date();
        var year = moment(date,"DD/MM/YYYY").year();
        var month =  moment(date,"DD/MM/YYYY").month(); 
        this.filterObj.dateEnd = new Date(year, month, day, 23, 59, 59, 999);
      }
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
        page: this.currentPage-1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, isHQUser: this.isHQUser
      }

      if(this.selectedCountry)
        this.filterObj.country = {id: this.selectedCountry.id};
      else{
        this.filterObj.country = null;
      }

      if (this.$route.params.filterObj) {
              if (this.$route.params.from == 'sol_dowpayment'){
                this.$route.params.from = null
                this.filterObj.idCountry = this.$route.params.filterObj.idCountry;
                
              }
              
            } else {
              this.setDate();
            }
      
      
      
      this.axios        
        .post('/ccb/auth/fe/downpayment/allPaged' , this.filterObj, {
          params: params,
          ...this.authHeader}          
        )
        .then(response => {
          this.items = response.data.content;
          /*this.items.forEach(data => {
            var market = data.country.codMercato;
            var dateStart = data.dateStart;
            var dateEnd = data.dateEnd;

            data.dateStart = new Date(MomentWithTimezone.utc(dateStart).tz(tz).format('MM DD YYYY HH:mm'))
            data.dateEnd = new Date( MomentWithTimezone.utc(dateEnd).tz(tz).format('MM DD YYYY HH:mm'));

            
          });*/
          this.totalRowsResult = response.data.totalElements;
          this.setSpinnerStatus(false);
        });
    },
    findCampaignById(id) {
      this.setSpinnerStatus(true);   
      this.axios
      .get('/ccb/auth/fe/solCampaign/'+id, this.authHeader)
        .then(response => {
          const  result = response.data;
          const  solCampaignModelList = response.data.solCampaignModel;
          this.curItem = result;
          this.itemsModel = [];
          solCampaignModelList.forEach(model => {
            this.itemsModel.push(model);
          });
          var tz = this.curItem.timeZone;
          var dateStart = this.curItem.dateStart;
          var dateEnd = this.curItem.dateEnd;

          this.curItem.dateStart = new Date(MomentWithTimezone.utc(dateStart).tz(tz).format('MM DD YYYY HH:mm'))
          this.curItem.dateEnd = new Date( MomentWithTimezone.utc(dateEnd).tz(tz).format('MM DD YYYY HH:mm'));
          this.$bvModal.show('modal-edit')       
        })
        .finally(() => { 
          this.setSpinnerStatus(false);
          this.$bvModal.show('modal-edit')} );                 
    },
    setItemsModel(solCampaignModel, idCountry, initialize){
      if(solCampaignModel && solCampaignModel.length > 0){
        let countryUser = this.countryList.find(country => country.id == idCountry);
        let listModels =  countryUser.modelGroupItemList;
        if(initialize)
          this.itemsModel = [];
        solCampaignModel.forEach(modelsUser => {
          let modelSelected = listModels.find(model => model.items.find(item => item.value == modelsUser.model));
          if(modelSelected){
            modelSelected =  modelSelected.items.find(value => value.value == modelsUser.model);
            var modelObj = {vetele: modelSelected.value, model: modelSelected.solLabel, statusExcel: modelsUser.statusExcel}
            this.itemsModel.push(modelObj);
            if(initialize)
              this.newItem.solCampaignModel.push({ model : { vetele : modelSelected.value}});
            else
            this.curItem.solCampaignModel.push(modelObj)
          }else if(!modelsUser.statusExcel){
            var modelObj = {vetele: modelsUser.model, model:  modelsUser.model, statusExcel: modelsUser.statusExcel}
            this.itemsModel.push(modelObj);
          }
        });
      }
    },    
   checkDownpaymentAndCreateItem(){   
    var country = this.newItem.country.id
    var downpayment = this.newItem.downpayment
        this.axios
        .get('/ccb/auth/fe/downpayment/checkDownpayment/'+country+'/'+downpayment, this.authHeader)
        .then(response => {
          if(response.status == 200){
            var statusCode = true;    
            console.log(response)        
            if(response.data == 1){
              statusCode = false;
              this.$bvModal.msgBoxOk('Downpayment value alredey exists for this country', {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          } else if (response.data == 0) {
            this.createItem();
          }
        }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
   },  
   checkDownpaymentAndSaveItem(curItem, editMode){   
    var country = curItem.country.id
    var downpayment = curItem.downpayment
        this.axios
        .get('/ccb/auth/fe/downpayment/checkDownpayment/'+country+'/'+downpayment, this.authHeader)
        .then(response => {
          if(response.status == 200){
            var statusCode = true;    
            console.log(response)        
            if(response.data == 1){
              statusCode = false;
              this.$bvModal.msgBoxOk('Downpayment value alredey exists for this country', {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          } else if (response.data == 0) {
            this.saveCurItem(curItem, editMode);
          }
        }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
   },  
    isNumber(evt = KeyboardEvent) {
      const keysAllowed  = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
      const keyPressed = evt.key;
      
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    disabledEndDatesGrid(dateStart){ 
      var dateWithTime = moment(dateStart);
      if(dateWithTime){
        dateWithTime.hour("00");
        dateWithTime.minutes("00");
        var date = moment(dateWithTime).add(1, 'd')._d;
        var disabledEndDates = {to :date};
        return disabledEndDates;
      }
    },
     enabledCurHoursEdit(dateStart){
      if(dateStart){
        var date = new Date(dateStart)
        if(date && date.toDateString() == new Date().toDateString()){
        const currentHour = new Date().getHours();
        return [ [ currentHour, 23 ] ];
      }
      }
     }, 
    enabledCurMinutesEdit(dateStart){  
      if(dateStart){
        var date = new Date(dateStart)
        var hourdate = date.getHours();
        var curHourDate = new Date().getHours();
        if(date.toDateString() == new Date().toDateString() && hourdate == curHourDate){
          const currentMinute = new Date().getMinutes();
          return [ [ currentMinute, 59 ] ];
        }
      }
    },
    disabledEndDates(){ 
      var dateWithTime = moment(this.newItem.dateTimeStartUTC);
      dateWithTime.hour("00");
      dateWithTime.minutes("00");
      var date = moment(dateWithTime).add(1, 'd')._d;
      var disabledEndDates = {to :date};

      return disabledEndDates;
    },
    refreshTable() {
      this.search();
    },
  atLastOneIsTrue(a,b,c){
        if ((a!=null && a > 0) || (b!=null && b > 0) || (c!=null && c > 0))
          return true
        else
          return false;
      },
    ...mapActions([
    'setCurApp',
    'setSpinnerStatus',
    'setLastSearch',
    'setComeFromSolCampaign',
    'setStartFromSolCampaign',
    'setOriginalCampaignObject'
    ]),
     scrollXPage (target, direction) {
      if(direction > 0) 
        this.$el.querySelector(target).parentNode.scrollLeft += this.$el.querySelector(target).clientWidth/4
      else
        this.$el.querySelector(target).parentNode.scrollLeft -= this.$el.querySelector(target).clientWidth/4
    },
    back(){      
      if(this.isFromPriceConf)
          this.$router.push({name: "price_configurator", params: { vetele : this.$route.params.vetele, idCountry: this.$route.params.idCountry, idCampaign : this.$route.params.idCampaign, filterObj: this.$route.params.filterObj, from: 'back_from_sol_dowpayment'}});
    },
    toogleNavButtons ( width, height ) {
      var overFlowTable = document.getElementById('table')
      if (width < overFlowTable.offsetWidth && (!this.showNavButtons || this.showNavButtons == null)) {
        this.showNavButtons = true
      } else if ((width == overFlowTable.offsetWidth || width > overFlowTable.offsetWidth) && (this.showNavButtons || this.showNavButtons == null)) {
        this.showNavButtons = false
      }
    },
    initialResizeCheck(tableResponsive, milliseconds){
      var ctx = this  
      var resizeCheck = setInterval(function(){
        if(ctx.counter < 3){
          ctx.counter++
          ctx.toogleNavButtons(tableResponsive.offsetWidth, 0)
        } else {
          clearInterval(resizeCheck)
        }
      }, milliseconds)
    }
  },
  props:["selectedCountryParam","veteleParam","idCampaignParam"],
  data () {
    return {
      oldDescription: null,
      importFromNewModal : false,
      curItemTemp: false,
      newItem : { id: null,
          country: {},
          downpayment: null,
          active: true,
          insertUser: null,
          insertDate: null,
          updateUser: null,
          updateDate: null
        },
      selectedEditModel: null,
      countryList: [],
      filterObj: {
          id: null,
          country: null,
          downpayment: null,
          active: true,
          insertUser: null,
          insertDate: null,
          updateUser: null,
          updateDate: null,
        },
      defaultFilterObj: {
        id: null,
        country: null,
        downpayment: null,
        active: null,
        insertDate: null,
        insertUser: null,
        updateDate: null,
        updateUser: null,
        countryList: [],
        }, 
      selectedNewModel: null,
      selectedScopeExport: true,
      selectedCountry : null,
      selectedModel : null,
      isHQUser : false,
      urlExport:' ',
      selected: false,
      options: [
        { value: true, text: 'ALL' },
        { value: false, text: 'FILTERED' },
      ],
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:15,
      sortBy:'id',
      sortDesc: true,
      curItem: null,
      fileName: '',
      isPostPriceConf: false,
      items: [],
      itemsModel: [],
      fieldsModel :  [
        {
          key: 'vetele',
          label: '',
          sortable: false,
          visible : false
        },
        {
          key: 'model',
          label: 'Downpayment',
          sortable: false,
          visible : true
        },
        {
          key: 'remove',
          label: 'Remove',
          sortable: false,
          visible : true
        },
        {
          key: 'detail',
          label: 'Detail',
          sortable: false,
          visible : true
        }
      ],
      fields :  [
        {
          key: 'market',
          label: 'Market',
          sortable: true,
          visible : true
        },        
        {
          key: 'downpayment',
          label: 'Downpayment',
          sortable: true,
          visible : true
        },
        {
          key: 'active',
          label: 'Delete',
          sortable: false,
          visible : true
        },
        {
          key: 'save',
          label: 'Save',
          sortable: false,
          visible : true
        }
        
      ],
      externallyLoaded: false,
      isFromPriceConf: false,
      showNavButtons: null,
      counter: 0,
      campaignTypeList : ['B2B','B2C']
    }
  },
  components: {
  	Datepicker,
    VueTimepicker
  },
  computed: {
    enabledStartHoursNew(){
      if(this.newItem && this.newItem.dateTimeStartUTC && this.newItem.dateTimeStartUTC.toDateString() == new Date().toDateString()){
        const currentHour = new Date().getHours();
        return [ [ currentHour, 23 ] ];
      }
     }, 
    enabledStartMinutesNew(){
      if(this.newItem && this.newItem.dateTimeStartUTC){
        var hourdate = this.newItem.dateTimeStartUTC.getHours();
        var curHourDate = new Date().getHours();
        if(this.newItem.dateTimeStartUTC.toDateString() == new Date().toDateString() && hourdate == curHourDate){
          const currentMinute = new Date().getMinutes();
          return [ [ currentMinute, 59 ] ];
        }
      }
    },   
    getTzFromIsoCode2(){
      if(this.newItem && this.newItem.country && this.newItem.country.isoCode2){
        var tzList = MomentWithTimezone.tz.zonesForCountry(this.newItem.country.isoCode2);
        if(tzList.length == 1) this.newItem.timeZone = tzList[0]; 
        else  this.newItem.timeZone = null;
        return tzList;
      } else  {
        this.newItem.timeZone = null;
        return [];
      }
    },
    getModelList(){
      if(!this.isPostPriceConf && !this.isFromPriceConf){
        this.filterObj.vetele = null;
        if(this.selectedCountry){
          return ((this.selectedCountry && this.selectedCountry.modelGroupItemList) ? this.selectedCountry.modelGroupItemList : [])
        } else{ 
          if(this.isHQUser){
            return this.selectedModel;
          }
        }
      }else{
        if(this.filterObj.vetele){
          if(this.selectedModel){
            var modelFind = this.selectedModel.find(models => models.items.find(model=> model.value == this.filterObj.vetele));
            return new Array(modelFind);
          }
          return new Array(this.filterObj.vetele);
        }
      }
    },
    disabledStartDates(){ 
      var disabledStartDates = {to : null};
      var date = new Date();
      date.setDate(date.getDate() - 1);
      var day = moment(date,"DD/MM/YYYY").date();
      var year = moment(date,"DD/MM/YYYY").year();
      var month =  moment(date,"DD/MM/YYYY").month(); 
      
      disabledStartDates.to = new Date(year, month, day, 23, 59, 59, 999);
      return disabledStartDates;
    },
    visibleFields() {
      return this.fields.filter(field => field.visible)
    },
    visibleFieldModels() {
      return this.fieldsModel.filter(fieldsModel => fieldsModel.visible)
    },
    ...mapGetters([
      'getCurLanguage',
      'getCurUser',
      'authHeader',
      'getComeFromSolCampaign',
      'getStartFromSolCampaign',
      'getOriginalCampaignObject'
    ])
  },
  watch:{
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      if(newValue)
        this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    },
    'newItem.modelDiscountValue': function (newVal, oldVal){
      if(newVal){
        document.querySelector('#newItemPerc').disabled = true; 
      }else{
        document.querySelector('#newItemPerc').disabled = false; 
      }
    },
    'newItem.modelDiscountPerc': function (newVal, oldVal){
      if(newVal){
        document.querySelector('#newItemValue').disabled = true; 
        if(newVal > 100){
          this.newItem.modelDiscountPerc = 100;
        }
      }else{
        document.querySelector('#newItemValue').disabled = false; 
      }
    },
    'newItem.optDiscountPerc': function (newVal, oldVal){
      if(newVal){
        if(newVal > 100){
          this.newItem.optDiscountPerc = 100;
        }
      }
    },
    'newItem.country': function (newVal, oldVal){
      this.itemsModel = [];
      this.selectedNewModel = null;
      this.newItem.solCampaignModel = [];
    },
    'newItem.dateTimeStartUTC': function (newVal, oldVal){
      if(newVal){
        if(!oldVal || (oldVal && oldVal.toDateString() != newVal.toDateString())){
          var dateWithTime = moment(newVal);
          dateWithTime.hour("00");
          dateWithTime.minutes("00");
          this.newItem.dateTimeStartUTC = dateWithTime._d;
          if(this.newItem.dateTimeEndUTC){
            if((newVal.getTime() > this.newItem.dateTimeEndUTC.getTime()) || (newVal.toDateString() == this.newItem.dateTimeEndUTC.toDateString())){
              var dateEndWithTime = moment(new Date(this.newItem.dateTimeEndUTC));
              if(dateEndWithTime){
                dateEndWithTime.hour("00");
                dateEndWithTime.minutes("00");
                this.newItem.dateTimeEndUTC = dateEndWithTime._d;
                var scope = this;
                setTimeout(function () {
                  scope.newItem.dateTimeEndUTC = null;
                }, 250);
              }
            }
          }
        } 
      }
    },
    'newItem.dateTimeEndUTC': function (newVal, oldVal){
      if(newVal){
        if(!oldVal || (oldVal && oldVal.toDateString() != newVal.toDateString())){
          var dateWithTime = moment(newVal);
          if(dateWithTime){
            dateWithTime.hour("00");
            dateWithTime.minutes("00");
            this.newItem.dateTimeEndUTC = dateWithTime._d;
          }
        }  
      }
    }
  },
  mounted() {
    window.scoper= this;
    var user = this.getCurUser;
    this.isHQUser = user.isHQUser != null ? user.isHQUser : false;
    this.setCurApp('sol_downpayment');
    if(this.isHQUser){
      this.countryList = ((user && user.countries && user.countries.length) ? user.countries : null);
    }else{
      this.countryList = ((user && user.countries && user.countries.length) ? user.countries.filter(country => country.solEnable) : null);
    }

    this.filterObj.countryList = this.countryList;
    var arr = new Array();
    this.countryList.forEach(a=>{ arr.push(a.id) })
    this.filterObj.countryList = arr
   
    if (this.$route.params.filterObj) {
      if(this.$route.params.from == 'price_conf'){
        this.filterObj = this.defaultFilterObj;
        this.isFromPriceConf = true;
        this.filterObj.id = this.$route.params.filterObj.id;
        //this.findCampaignById(this.$route.params.idCampaign);
        
      } else if(this.$route.params.from == 'sol_dowpayment'){
        console.log("--")
        console.log(this.getOriginalCampaignObject)
        console.log("++++++++++")
        console.log(this.$route.params.filterObj)
        this.filterObj = this.getOriginalCampaignObject;
      }      
    } 

    this.refreshTable();
    

    var oldcss = this.$el.querySelector("#overflow_nav_buttons").style.cssText
    this.$el.querySelector("#overflow_nav_buttons").style.cssText = oldcss + "-ms-grid-rows: (1fr)[7]; -ms-grid-columns: (1fr)[12];"

    var tableResponsive = document.getElementsByClassName('table-responsive')

    function closeTimeDatePickers() {
      var timepickers = document.getElementsByClassName('drop-down');
      var datepickers = document.getElementsByClassName('vdp-datepicker__calendar');
      // console.log(timepickers)
      // console.log(datepickers)
      for(var i = 0; i < timepickers.length ; i++) {
        timepickers[i].style.display = 'none'
      }
      for(var i = 0; i < datepickers.length ; i++) {
        datepickers[i].style.display = 'none'
      }
    }
    for(var i = 0; i < tableResponsive.length ; i++) {
      tableResponsive[i].addEventListener('scroll', (e) => {
        closeTimeDatePickers()
      });
    }
    
    this.initialResizeCheck(tableResponsive[0], 2000)
    }
}

window.adjustPositionTime = function(element) {
  var dropdown = element.querySelector('.dropdown');
  var offset = element.offsetTop;
  var currentRow = element.parentElement.parentElement.parentElement.parentElement.getAttribute('aria-rowindex');
  var rowCount = document.getElementById('table').rows.length - 1;
  var items = document.getElementById('perPage-dd').value;
  var rowDifference = rowCount - currentRow;

  // set approproate position relative to table size
  if(rowCount < 5) {
    dropdown.parentElement.style.position = "inherit"
  } else {
    dropdown.parentElement.style.position = "relative"
  }

  //detect if current row is too close to last row
  if(rowDifference < 3 ) {
    //current row is too close to the end of the table
    //detect if table is too small
    if(rowCount < 5){
      //rowcount is low, the table is too small
      if(element.classList.contains('modal-timepicker')) {
        //ignore for modal timepicker
        dropdown.style.top = '2.2em';
      } else {
        //adjust accordingly
        if(currentRow == '1'){
          dropdown.style.top = '37px';
        } else if (currentRow == '2') {
          dropdown.style.top = '98px';
        } else if (currentRow == '3') {
          dropdown.style.top = '159px';
        }
      }
    } else {
      //rowcount is ok
      if(element.classList.contains('modal-timepicker')) {
        dropdown.style.top = '2.2em';
      } else {
        dropdown.style.top = 'calc(-10em - 1px)';
      }
    }

    //show timepicker
    setTimeout(() => {
      if(dropdown.style.opacity != 0 || dropdown.style.display == 'none'){
        dropdown.style.opacity = 0;
      } else {
        dropdown.style.opacity = 1;
      }
    }, 150)
  } else {
    //current row is NOT close to the end of the table
    //detect if table is too small
    if(rowCount < 5){
        //table is too small and needs to be managed
        if(currentRow == '1'){
          dropdown.style.top = '37px';
        } else if (currentRow == '2') {
          dropdown.style.top = '98px';
        } else if (currentRow == '3') {
          dropdown.style.top = '153px';
        } else if (currentRow == '4') {
          dropdown.style.top = '220px';
        } else if (currentRow == '5') {
          dropdown.style.top = '281px';
        }
    } else {
        dropdown.style.top = '2.15em';
    }
    setTimeout(() => {
      if(dropdown.style.opacity != 0 || dropdown.style.display == 'none'){
        dropdown.style.opacity = 0;
      } else {
        dropdown.style.opacity = 1;
      }
    }, 150)
  }
};

window.adjustPositionDate = function(element) {
  var calendar = element.querySelector('.vdp-datepicker__calendar');
  var offset = calendar.offsetTop
  var currentRow = element.parentElement.parentElement.parentElement.parentElement.getAttribute('aria-rowindex');
  var rowCount = document.getElementById('table').rows.length - 1;
  var items = document.getElementById('perPage-dd').value;
  var rowDifference = rowCount - currentRow;

  if(rowCount < 5 || rowDifference < 3) {
    calendar.style.transform = 'translate(-1px,-290px)';
  } else {
    calendar.style.transform = 'translate(0,0)';
  }
};

</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.datepicker {
  width: 100%;
}
</style>